function labelize(value) {
  return String(value ?? '')
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function getSpeciesUuid(species) {
  return species?.uuid ?? species?.id ?? species?.species_id ?? species?.speciesUuid ?? '';
}

export function getSpeciesCode(species) {
  return species?.species_code ?? species?.speciesCode ?? species?.code ?? '';
}

function normalizePurposeOption(item) {
  if (item == null) return null;

  if (typeof item === 'string' || typeof item === 'number') {
    const value = String(item).trim();
    return value ? { value, label: labelize(value) } : null;
  }

  const value = String(
    item.uuid ??
    item.id ??
    item.purpose_uuid ??
    item.purposeId ??
    item.purpose_code ??
    item.purposeCode ??
    item.code ??
    item.value ??
    ''
  ).trim();

  if (!value) return null;

  const label = String(
    item.purpose_label ??
    item.purposeLabel ??
    item.label ??
    item.name ??
    item.title ??
    value
  ).trim() || value;

  return { value, label, raw: item };
}

function speciesMatches(item, speciesUuid, selectedSpeciesCode) {
  if (!speciesUuid) return true;

  const itemSpeciesUuid = String(item?.species_uuid ?? item?.speciesUuid ?? '').trim();
  const itemSpeciesCode = String(item?.species_code ?? item?.speciesCode ?? '').trim();

  return (
    (itemSpeciesUuid && itemSpeciesUuid === speciesUuid) ||
    (selectedSpeciesCode && itemSpeciesCode && itemSpeciesCode === selectedSpeciesCode)
  );
}

export function buildProductionPurposeOptions({
  speciesUuid = '',
  speciesList = [],
  productionPurposes = [],
} = {}) {
  const registry = Array.isArray(productionPurposes) ? productionPurposes : [];
  if (registry.length === 0) return [];

  const selectedSpecies = speciesList.find((species) =>
    getSpeciesUuid(species) === speciesUuid || getSpeciesCode(species) === speciesUuid
  ) ?? null;
  const selectedSpeciesCode = getSpeciesCode(selectedSpecies);

  return registry
    .filter((item) => speciesMatches(item, speciesUuid, selectedSpeciesCode))
    .map(normalizePurposeOption)
    .filter(Boolean)
    .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));
}

export function resolveProductionPurposeValue(
  value,
  { speciesUuid = '', speciesList = [], productionPurposes = [] } = {}
) {
  const current = String(value ?? '').trim();
  if (!current) return '';

  const registry = Array.isArray(productionPurposes) ? productionPurposes : [];
  const selectedSpecies = speciesList.find((species) =>
    getSpeciesUuid(species) === speciesUuid || getSpeciesCode(species) === speciesUuid
  ) ?? null;
  const selectedSpeciesCode = getSpeciesCode(selectedSpecies);

  const match = registry.find((item) => {
    if (!speciesMatches(item, speciesUuid, selectedSpeciesCode)) return false;

    const itemUuid = String(item?.uuid ?? item?.id ?? item?.purpose_uuid ?? item?.purposeId ?? '').trim();
    const itemCode = String(item?.purpose_code ?? item?.purposeCode ?? item?.code ?? '').trim();
    return itemUuid === current || itemCode === current;
  });

  return String(match?.uuid ?? match?.id ?? current).trim();
}

export function getProductionPurposeLabel(value, options = []) {
  const current = String(value ?? '').trim();
  if (!current) return '—';

  const option = Array.isArray(options)
    ? options.find((item) => String(item?.value ?? '').trim() === current)
    : null;

  return option?.label ?? labelize(current);
}
